module.exports = __webpack_public_path__ + "static/media/psiquiatra.a82ca997.png";